import axios from '../../utils/axiosConfig';

// Action types
export const GET_USER_EMAILS_REQUEST = 'GET_USER_EMAILS_REQUEST';
export const GET_USER_EMAILS_SUCCESS = 'GET_USER_EMAILS_SUCCESS';
export const GET_USER_EMAILS_FAILURE = 'GET_USER_EMAILS_FAILURE';

export const ADD_USER_EMAIL_REQUEST = 'ADD_USER_EMAIL_REQUEST';
export const ADD_USER_EMAIL_SUCCESS = 'ADD_USER_EMAIL_SUCCESS';
export const ADD_USER_EMAIL_FAILURE = 'ADD_USER_EMAIL_FAILURE';

export const DELETE_USER_EMAIL_REQUEST = 'DELETE_USER_EMAIL_REQUEST';
export const DELETE_USER_EMAIL_SUCCESS = 'DELETE_USER_EMAIL_SUCCESS';
export const DELETE_USER_EMAIL_FAILURE = 'DELETE_USER_EMAIL_FAILURE';

export const SET_PRIMARY_EMAIL_REQUEST = 'SET_PRIMARY_EMAIL_REQUEST';
export const SET_PRIMARY_EMAIL_SUCCESS = 'SET_PRIMARY_EMAIL_SUCCESS';
export const SET_PRIMARY_EMAIL_FAILURE = 'SET_PRIMARY_EMAIL_FAILURE';

/**
 * Get all email addresses for the current user
 */
export const getUserEmails = () => async (dispatch) => {
	try {
		dispatch({ type: GET_USER_EMAILS_REQUEST });

		const response = await axios.get('/api/user/emails');

		if (response.data.status) {
			dispatch({
				type: GET_USER_EMAILS_SUCCESS,
				payload: response.data.emails
			});
			return response.data;
		} else {
			dispatch({
				type: GET_USER_EMAILS_FAILURE,
				payload: response.data.msg || 'Failed to fetch emails'
			});
			return response.data;
		}
	} catch (error) {
		const errorMsg = error.response?.data?.msg || error.message || 'Network error fetching emails';
		dispatch({
			type: GET_USER_EMAILS_FAILURE,
			payload: errorMsg
		});
		return { status: false, msg: errorMsg };
	}
};

/**
 * Add a new email address for the current user
 * @param {string} emailAddress - The email address to add
 */
export const addUserEmail = (emailAddress) => async (dispatch) => {
	try {
		dispatch({ type: ADD_USER_EMAIL_REQUEST });

		const response = await axios.post('/api/user/emails/add', {
			emailAddress
		});

		if (response.data.status) {
			dispatch({
				type: ADD_USER_EMAIL_SUCCESS,
				payload: {
					id: response.data.emailId,
					emailAddress,
					isPrimary: response.data.isPrimary,
					createdDate: new Date().toISOString()
				}
			});
			// Refresh the email list
			dispatch(getUserEmails());
			return response.data;
		} else {
			dispatch({
				type: ADD_USER_EMAIL_FAILURE,
				payload: response.data.msg || 'Failed to add email'
			});
			return response.data;
		}
	} catch (error) {
		const errorMsg = error.response?.data?.msg || error.message || 'Network error adding email';
		dispatch({
			type: ADD_USER_EMAIL_FAILURE,
			payload: errorMsg
		});
		return { status: false, msg: errorMsg };
	}
};

/**
 * Delete an email address
 * @param {number} emailId - The ID of the email to delete
 */
export const deleteUserEmail = (emailId) => async (dispatch) => {
	try {
		dispatch({ type: DELETE_USER_EMAIL_REQUEST });

		const response = await axios.post('/api/user/emails/delete', {
			emailId
		});

		if (response.data.status) {
			dispatch({
				type: DELETE_USER_EMAIL_SUCCESS,
				payload: emailId
			});
			// Refresh the email list
			dispatch(getUserEmails());
			return response.data;
		} else {
			dispatch({
				type: DELETE_USER_EMAIL_FAILURE,
				payload: response.data.msg || 'Failed to delete email'
			});
			return response.data;
		}
	} catch (error) {
		const errorMsg = error.response?.data?.msg || error.message || 'Network error deleting email';
		dispatch({
			type: DELETE_USER_EMAIL_FAILURE,
			payload: errorMsg
		});
		return { status: false, msg: errorMsg };
	}
};

/**
 * Set an email as the primary email
 * @param {number} emailId - The ID of the email to set as primary
 */
export const setPrimaryEmail = (emailId) => async (dispatch) => {
	try {
		dispatch({ type: SET_PRIMARY_EMAIL_REQUEST });

		const response = await axios.post('/api/user/emails/set-primary', {
			emailId
		});

		if (response.data.status) {
			dispatch({
				type: SET_PRIMARY_EMAIL_SUCCESS,
				payload: emailId
			});
			// Refresh the email list
			dispatch(getUserEmails());
			return response.data;
		} else {
			dispatch({
				type: SET_PRIMARY_EMAIL_FAILURE,
				payload: response.data.msg || 'Failed to set primary email'
			});
			return response.data;
		}
	} catch (error) {
		const errorMsg = error.response?.data?.msg || error.message || 'Network error setting primary email';
		dispatch({
			type: SET_PRIMARY_EMAIL_FAILURE,
			payload: errorMsg
		});
		return { status: false, msg: errorMsg };
	}
};


